export default __webpack_public_path__ + "static/media/ai_motion.cb1d443b.svg";